'use strict';

module.exports = ['$filter', function ($filter) {
        var translate = $filter('translate');
        return {
            getKeyValue: function (key) {
                return translate(key);
            }
        };
    }
];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/services/HandlerLanguage.js
// module id = 437
// module chunks = 0